import Upsertable from '@/models/Upsertable'
import { useAgriApplicationStore } from '@/stores/agriApplicationStore'
import AgriProduct from '@/models/AgriProduct.js'
import { reactive, toRaw } from 'vue'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class AgriApplication extends Upsertable {
  static store() {
    return useAgriApplicationStore()
  }

  store() {
    return AgriApplication.store()
  }

  agriProduct() {
    if (this._agriProduct) return this._agriProduct

    let agriProduct = Object.assign(new AgriProduct(), { uuid: this.agri_product.uuid })
    this._agriProduct = reactive(agriProduct)

    AgriProduct.store().getRecord(this.agri_product.uuid).then((rawRecord) => {
      agriProduct = Object.assign(new AgriProduct(), toRaw(rawRecord))
      Object.assign(this._agriProduct, agriProduct)
    })

    return this._agriProduct
  }

  static find(uuid) {
    return AgriApplication.store().find(uuid)
  }
  
}

useModelName(AgriApplication, "AgriApplication")
ModelRegistry.register(AgriApplication, "AgriApplication")